import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';

import { TGlobalDataLayer, TCustomerJourney } from '../../Types';

declare global {
  interface Window {
    dataLayer?: TGlobalDataLayer;
  }
}

/**
 * @deprecated
 */
export const CUSTOMERJOURNEY_STORAGE_KEY = '_CUSTOMERJOURNEY';

/**
 * @deprecated
 */
export const initialize = ({
  customerJourney,
  trackWithDataAttribute = false,
}: {
  customerJourney?: TCustomerJourney;
  trackWithDataAttribute?: boolean;
} = {}) => {
  if (!customerJourney)
    return console.error(
      '[TRACKING] No customer journey provided to initialization call',
    );

  if (typeof window !== 'undefined') {
    lodashSet(window, CUSTOMERJOURNEY_STORAGE_KEY, customerJourney);

    if (trackWithDataAttribute) {
      window.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        const trackingId = target.getAttribute('data-tracking-id');

        if (trackingId === null) return;

        trackClick({ identifier: trackingId });
      });
    }
  }
};

/**
 * @deprecated
 */
export const identifyUser = (
  statekey: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  { isIntroducer = false }: { isIntroducer?: boolean } = {},
) => {
  identify(statekey);
};

/**
 * @deprecated
 */
export interface TrackEventOptions {
  category?: TCustomerJourney;
  event: string;
  label?: string;
  value?: number;
}

/**
 * @deprecated
 */
export const trackClick = ({
  customerJourney,
  identifier,
  deviceType,
}: {
  customerJourney?: TCustomerJourney;
  identifier: string;
  deviceType?: string;
}) => {
  const category = getGlobalCustomerJourney(customerJourney);

  const event = 'Click';
  const label = Boolean(deviceType)
    ? `${identifier} [${deviceType}]`
    : identifier;

  trackEvent({ category, event, label });
};

const formInteractions = ['View', 'Submit', 'Error'];
/**
 * @deprecated
 */
export const trackForm = ({
  customerJourney,
  interaction,
  formName: label,
  additionalValue: value,
}: {
  customerJourney?: TCustomerJourney;
  interaction: 'View' | 'Submit' | 'Error';
  formName: string;
  additionalValue?: number;
}) => {
  if (!formInteractions.includes(interaction)) return;

  const event = `${interaction} Form`;
  const category = getGlobalCustomerJourney(customerJourney);

  trackEvent({ category, event, label, value });
};

const formFieldInteractions = ['Change', 'Error'];
/**
 * @deprecated
 */
export const trackFormField = ({
  customerJourney,
  formName,
  fieldName,
  fieldValue,
  interaction,
}: {
  customerJourney?: TCustomerJourney;
  formName: string;
  fieldName: string;
  fieldValue?: string | number | boolean;
  interaction: 'Change' | 'Error';
}) => {
  if (typeof fieldName !== 'string' || fieldName === 'false') return;
  if (!formFieldInteractions.includes(interaction)) return;

  const category = getGlobalCustomerJourney(customerJourney);
  const event = `Form-field ${interaction}`;

  let label = `${formName} - ${fieldName}`;
  if (fieldValue !== undefined) {
    label += ` - ${fieldValue}`;
  }

  trackEvent({ category, event, label });
};

/**
 * @deprecated
 */
export const trackSlider = ({
  customerJourney,
  sliderName,
  sliderValue: value,
}: {
  customerJourney?: TCustomerJourney;
  sliderName: string;
  sliderValue: number;
}) => {
  const category = getGlobalCustomerJourney(customerJourney);
  const event = 'Slider change';
  const label = `${sliderName} Slider`;

  trackEvent({ category, event, label, value });
};

/**
 * @deprecated
 */
export const trackError = ({
  customerJourney,
  identifier: label,
}: {
  customerJourney?: TCustomerJourney;
  identifier: string;
}) => {
  const category = getGlobalCustomerJourney(customerJourney);
  const event = 'Show Error';

  trackEvent({ category, event, label });
};

const modalInteractions = ['Open', 'Close'];
/**
 * @deprecated
 */
export const trackModal = ({
  customerJourney,
  interaction,
  modalName: label,
}: {
  customerJourney?: TCustomerJourney;
  interaction: 'Open' | 'Close';
  modalName: string;
}) => {
  if (!modalInteractions.includes(interaction)) return;

  const event = `${interaction} Modal`;
  const category = getGlobalCustomerJourney(customerJourney);

  trackEvent({ category, event, label });
};

/**
 * @deprecated
 */
export const trackEvent = ({
  category: customerJourney,
  event,
  label,
  value,
}: TrackEventOptions) => {
  const category = getGlobalCustomerJourney(customerJourney);
  // Tag manager relies on this being prefixed with [SEGMENT]
  // So it can filter for it and pass it to GA
  const GTMEventName = `[SEGMENT] ${event}`;

  track(GTMEventName, { category, label, value });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function pushToDataLayer(args: any) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(args);
  }
}

/**
 * @deprecated
 */
export function identify(stateKey: string) {
  pushToDataLayer({
    event: 'addedStateKeyToUser',
    state_key: stateKey,
  });
}

/**
 * @deprecated
 */
export function track(
  eventName: string,
  eventData?: { [key: string]: string | number | boolean | null | undefined },
) {
  pushToDataLayer({
    event: eventName,
    ...eventData,
  });
}

/**
 * @deprecated
 */
export function viewPage(pathname: string) {
  pushToDataLayer({
    event: 'simulatePageView',
    pathname,
  });
}

const getGlobalCustomerJourney = (
  customerJourney?: TCustomerJourney,
): TCustomerJourney => {
  if (customerJourney) {
    return customerJourney;
  }

  // @ts-expect-error window could be undefined and hence returning undefined for this function
  return window && lodashGet(window, CUSTOMERJOURNEY_STORAGE_KEY);
};
